import React, { createContext, useEffect, useRef, useState } from "react";
import CustomTable from "../../Table/CustomTable";
import getWalletPayoutRequests from "../../../controllers/settings/wallet/getWalletPayoutRequests";
import { formatMoney } from "../../../features/utils/formatMoney";
import Icon from "../../HOC/Icon";
import { CircularProgress, Menu, MenuItem, TextField } from "@mui/material";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import Button1 from "../../form/Button1";
import acceptPayoutRequest from "../../../controllers/settings/wallet/acceptPayoutRequest";
import { enqueueSnackbar } from "notistack";
import rejectPayoutRequest from "../../../controllers/settings/wallet/rejectPayoutRequest";
import { alertType } from "../../../data/constants";
import getAgentBankAccount from "../../../controllers/Bank/getAgentBanks";
import CopyText from "../../mini/CopyText";
import confirmManualPayoutRequest from "../../../controllers/settings/wallet/confirmManualPayoutRequest";
import isPayoutOTPNeeded from "../../../controllers/settings/wallet/isPayoutOTPNeeded";
import finalizePayout from "../../../controllers/settings/wallet/finalizePayout";
import resendPayoutOTP from "../../../controllers/settings/wallet/resendPayoutOTP";
import OTPInput from "../../Auth/OTPInput";
import useAccount from "../../../hooks/useAccount";
import refreshPayoutRequest from "../../../controllers/settings/wallet/refreshPayoutRequest";
import moment from "moment";

const ActionsContext = createContext();

export default function PayoutTable() {
  const [data, setData] = useState([]);
  const [openReject, setOpenReject] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [view, setView] = useState();
  const [loadings, setLoadings] = useState({
    load: false,
    accept: false,
    reject: false,
  });

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
    rowCount: 0,
  });

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    load();

    //eslint-disable-next-line
  }, [paginationModel?.page, searchValue]);

  useEffect(() => {
    if (view && !view?.fetched) loadBankDetails();
    //eslint-disable-next-line
  }, [view]);

  async function load() {
    const query = {
      limit: paginationModel?.pageSize,
      offset: paginationModel?.page * paginationModel?.pageSize,
    };
    if (searchValue) {
      query.searchBy =
        "bankAccount,ammount,status,account.firstName,account.lastName,account.email,account.phone";
      query.keyword = searchValue;
    }

    setLoadings({ ...loadings, load: true });
    const res = await getWalletPayoutRequests(
      new URLSearchParams(query)?.toString()
    );
    setLoadings({ ...loadings, load: false });
    if (res?.return) {
      setData(res?.data?.data);
      setPaginationModel({
        ...paginationModel,
        rowCount: res?.data?.meta?.total,
      });
    }
  }

  async function loadBankDetails() {
    const res = await getAgentBankAccount(view?.account?._id);
    if (res?.return) {
      setView({
        ...view,
        bankDetails: res?.data?.data?.find(
          (obj) => obj?._id === view?.bankAccount
        ),
        fetched: true,
      });
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setView({ fetched: true });
    }
  }
  console.log(view);

  const columns = [
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1,
      renderCell: (params) => (
        <div>{moment(params?.value).format("DD/MM/YYYY HH:mm A")}</div>
      ),
    },
    {
      field: "user",
      headerName: "User",
      flex: 1,
      renderCell: (params) => (
        <div>
          {params?.row?.account?.firstName || ""}{" "}
          {params?.row?.account?.middleName || ""}{" "}
          {params?.row?.account?.lastName || ""}
        </div>
      ),
    },
    {
      field: "bankAccount",
      headerName: "Payout Reference",
      flex: 1,
      renderCell: (params) => <div>{params?.value}</div>,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      renderCell: (params) => <div>{formatMoney(params?.value)}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => <StatusCol params={params} />,
    },
  ];

  async function handleAccept(ev) {
    ev?.preventDefault();

    const payload = {
      requestPayoutId: openAccept?._id,
    };
    setLoadings({ ...loadings, accept: true });
    const res = await acceptPayoutRequest(payload);
    setLoadings({ ...loadings, accept: false });
    if (res?.return) {
      const reqOTP = await isPayoutOTPNeeded(payload);
      if (reqOTP?.return)
        if (reqOTP?.data?.isOTPNeeded) return setOpenOTPModal(payload);
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpenAccept(false);
      load();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function handlePayoutOTP(ev) {
    ev?.preventDefault();

    const payload = {
      requestPayoutId: openOTPModal?._id || openAccept?._id,
      otp: openOTPModal?.otp,
    };
    setLoadings({ ...loadings, otp: true });
    const res = await finalizePayout(payload);
    setLoadings({ ...loadings, otp: false });
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpenOTPModal(false);
      load();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function handleConfirmManually(ev) {
    ev?.preventDefault();

    const payload = {
      requestPayoutId: openConfirm?._id,
    };
    setLoadings({ ...loadings, confirmManual: true });
    const res = await confirmManualPayoutRequest(payload);
    setLoadings({ ...loadings, confirmManual: false });
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpenConfirm(false);
      load();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function handleReject(ev) {
    ev?.preventDefault();

    const payload = {
      requestPayoutId: openReject?._id,
      reason: openReject?.reason,
    };
    setLoadings({ ...loadings, reject: true });
    const res = await rejectPayoutRequest(payload);
    setLoadings({ ...loadings, reject: false });
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpenReject(false);
      load();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function handleResendOTP() {
    setLoadings({ ...loadings, resendOTP: true });
    const res = await resendPayoutOTP(openOTPModal?._id);
    setLoadings({ ...loadings, resendOTP: false });
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function refresh(row) {
    const res = await refreshPayoutRequest(row?._id);
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      load();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  //   console.log({ openAccept });

  return (
    <div>
      <ActionsContext.Provider
        value={{
          accept: setOpenAccept,
          reject: setOpenReject,
          view: setView,
          refresh,
          confirmManually: setOpenConfirm,
          setOpenOTPModal,
        }}
      >
        <CustomTable
          loading={loadings?.load}
          columns={columns}
          rows={data}
          searchProps={{
            searchable: true,
            search: setSearchValue,
          }}
          rowCount={paginationModel?.rowCount}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </ActionsContext.Provider>

      <Modal3 title="Bank Details" open={view} setOpen={() => setView(false)}>
        <div className="p-6">
          {!view?.fetched ? (
            <div className="py-6 flex justify-center">
              <CircularProgress />
            </div>
          ) : (
            <div className="flex flex-col gap-2 min-w-[350px]">
              <b>{view?.bankDetails?.accountName}</b>
              <div className="flex gap-4 justify-between">
                {view?.bankDetails?.bankName} | {view?.bankDetails?.bankCode}
                <label>
                  <CopyText>
                    <input
                      className="text-end"
                      type="text"
                      disabled={true}
                      value={view?.bankDetails?.accountNumber}
                    />
                  </CopyText>
                </label>
              </div>
            </div>
          )}
        </div>
      </Modal3>
      <Modal3
        title="Approve Payout"
        open={openAccept}
        setOpen={() => setOpenAccept(false)}
      >
        <form onSubmit={handleAccept} className="p-6 flex flex-col gap-4">
          <p>Are you sure you want to approve this payout request?</p>
          <div className="flex gap-2 items-center">
            <div>
              <Button1
                type="button"
                variant="outlined"
                onClick={() => setOpenAccept(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1 type="submit" loading={loadings?.accept}>
              Confirm
            </Button1>
          </div>
        </form>
      </Modal3>
      <Modal3
        title="Confirm Manually"
        open={openConfirm}
        setOpen={() => setOpenConfirm(false)}
      >
        <form
          onSubmit={handleConfirmManually}
          className="p-6 flex flex-col gap-4"
        >
          <p>
            Are you sure you the agent has received their money to their bank?
          </p>
          <div className="flex gap-2 items-center">
            <div>
              <Button1
                type="button"
                variant="outlined"
                onClick={() => setOpenConfirm(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1 type="submit" loading={loadings?.confirmManual}>
              Confirm
            </Button1>
          </div>
        </form>
      </Modal3>
      <Modal3
        title="Payout OTP"
        open={openOTPModal}
        setOpen={() => setOpenOTPModal(false)}
      >
        <form onSubmit={handlePayoutOTP} className="p-6 flex flex-col gap-4">
          <div>Enter OTP</div>
          <div className="max-w-[500px]">
            <OTPInput
              label="OTP"
              value={openOTPModal?.otp || ""}
              onChange={(otp) => setOpenOTPModal({ ...openOTPModal, otp })}
            />
          </div>
          <div className="flex justify-end gap-2">
            <div>
              <Button1
                loading={openOTPModal?.resendOTP}
                variant="text"
                onClick={() => handleResendOTP()}
              >
                Resend OTP
              </Button1>
            </div>
          </div>

          <div className="flex gap-2 items-center">
            <div>
              <Button1
                type="button"
                variant="outlined"
                onClick={() => setOpenOTPModal(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1 type="submit" loading={loadings?.reject}>
              Confirm
            </Button1>
          </div>
        </form>
      </Modal3>
      <Modal3
        title="Reject Payout"
        open={openReject}
        setOpen={() => setOpenReject(false)}
      >
        <form onSubmit={handleReject} className="p-6 flex flex-col gap-4">
          <TextField
            multiline
            rows={4}
            label="Reason"
            value={openReject?.reason || ""}
            onChange={(ev) =>
              setOpenReject({ ...openReject, reason: ev.target.value })
            }
          />
          <div className="flex gap-2 items-center">
            <div>
              <Button1
                type="button"
                variant="outlined"
                onClick={() => setOpenReject(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1 type="submit" loading={loadings?.reject}>
              Confirm
            </Button1>
          </div>
        </form>
      </Modal3>
    </div>
  );
}

function StatusCol({ params }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const [loading, setLoading] = useState({ Refresh: false });
  const { checkPermission } = useAccount();

  async function handleClick(callback, stay) {
    if (!stay) setOpen(false);
    callback && (await callback());
  }

  function getStatus(stat) {
    if (stat?.toLowerCase()?.includes("waiting")) return "Pending";
    return stat;
  }

  const CustomMenuItem = ({ label, onClick, showFor }) => {
    const disabled = showFor && !showFor?.includes(params.value);
    return (
      <MenuItem
        onClick={async () =>
          !disabled && (await handleLoading(label, async () => await onClick()))
        }
        disabled={disabled}
        className="flex gap-2 items-center"
      >
        {loading[label] ? <CircularProgress size={15} /> : null}
        {label}
      </MenuItem>
    );
  };

  //   console.log(loading);

  async function handleLoading(type, callback) {
    setLoading({ ...loading, [type]: true });
    await callback();
    setLoading({ ...loading, [type]: false });
  }

  const status = getStatus(params?.row?.status);

  return (
    <div className="flex gap-2 items-center w-full justify-between">
      <span className={`${alertType[status?.toLowerCase()]}`}>{status}</span>
      <button>
        <Icon
          icon="mdi:dots-vertical"
          onClick={(ev) => setOpen(ev.currentTarget)}
          ref={menuRef}
        />
        <ActionsContext.Consumer>
          {(value) => {
            const {
              accept,
              reject,
              confirmManually,
              setOpenOTPModal,
              view,
              refresh,
            } = value || {};
            return (
              <Menu
                anchorEl={open}
                open={Boolean(open)}
                onClose={() => setOpen(false)}
              >
                <CustomMenuItem
                  onClick={() => handleClick(() => view(params?.row))}
                  label="View Details"
                />
                {checkPermission(["approve:payout-request"]) ? (
                  <CustomMenuItem
                    onClick={() => handleClick(() => accept(params?.row))}
                    label="Auto Pay"
                    showFor={["WaitingApproval"]}
                  />
                ) : null}

                {checkPermission(["confirm:manual-payout"]) ? (
                  <CustomMenuItem
                    onClick={() =>
                      handleClick(() => confirmManually(params?.row))
                    }
                    label="Manual Pay"
                    showFor={["WaitingApproval", "InitiatedPayout"]}
                  />
                ) : null}

                {params.value === "InitiatedPayout" &&
                checkPermission(["approve:payout-request"]) ? (
                  <CustomMenuItem
                    onClick={() =>
                      handleClick(() => setOpenOTPModal(params?.row))
                    }
                    label="Confirm OTP"
                    showFor={["InitiatedPayout"]}
                  />
                ) : null}

                {checkPermission(["reject:payout-request"]) ? (
                  <CustomMenuItem
                    onClick={() => handleClick(() => reject(params?.row))}
                    label="Reject"
                    // TEMP: include Rejected so we can re-hit reject and see backend response
                    showFor={["WaitingApproval", "Rejected"]}
                  />
                ) : null}

                <CustomMenuItem
                  onClick={async () =>
                    await handleClick(
                      async () => await refresh(params?.row),
                      true
                    )
                  }
                  label="Refresh"
                />
              </Menu>
            );
          }}
        </ActionsContext.Consumer>
      </button>
    </div>
  );
}
